import { PREFIX, Theme, TypographyStyles } from './theme';
import { CSSProperties } from 'react';

const getTypes = (theme: Theme) =>
    Object.keys(theme.typography).filter(
        (key) => !['fontFamily', 'fontImports'].includes(key)
    );

function convertCamelToHyphen(cssPropertyName: string): string {
    return cssPropertyName.replace(
        /[A-Z]/g,
        (match) => `-${match.toLowerCase()}`
    );
}

function propsToString(props: CSSProperties): string {
    if (!props) {
        return '';
    }
    return Object.keys(props)
        .map((key) => {
            return `  ${convertCamelToHyphen(key)}: ${
                props[key as keyof CSSProperties]
            };`;
        })
        .join('\n');
}

export const buildTypography = (theme: Theme, global: boolean) => {
    const root = global ? ':root' : `.${PREFIX}-root`;
    return `
${root} {    
    font-family: ${theme.typography.fontFamily};
    color: ${theme.text.light.default};
}   

${getTypes(theme)
    .map(
        (type) => `
.${PREFIX}-text-${type} {
    ${propsToString(
        theme.typography[type as keyof TypographyStyles] as CSSProperties
    )}
}`
    )
    .join('\n')}

`;
};

function fontImportsToString(imports: Theme['typography']['fontImports'] = []) {
    return imports.map((font) => `@import url('${font}');`).join('\n');
}

export const buildFontImports = (theme: Theme) => {
    return fontImportsToString(theme.typography.fontImports);
};
